import { en, fi, de, sv, nl, ja } from "./locales";

export const configuration = {
  languages: {
    decks: [
      "fi",
      "en",
      "de",
      "sv",
      "nl",
      "ja",
    ],

    ui: {
      cache: {
        key: "language",
        sources: ["localStorage", "cookie"],
      },
      debug: false,
      fallback: "en",
      resources: {
        en,
        fi,
        de,
        sv,
        nl,
        ja,
      },
    },
  },
};
